import { APP_BASE_HREF } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { FormDataService } from '@app/_core/services/form-data.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { MainControllerComponent } from '@app/pages/queue/dialer/MainController.component';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-disconnect-call',
  templateUrl: './disconnect-call.component.html',
  styleUrl: './disconnect-call.component.scss'
})
export class DisconnectCallComponent implements OnInit,AfterViewInit {
  callDisposition:any=0;
  dispositions:any;
  notes:any;
  activityId: any;
  selectedUserID: any;
  invalidDisposition:boolean=false;
  queueType: any;
  modalRef?: BsModalRef;
  constructor(
    private fb: FormBuilder,
    private queueService: QueuesService,
    private managerService: ManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private appService: AppService,
    private queueServices: QueuesService,
    private cdref: ChangeDetectorRef,
    private tmQueueService: TmQueueService,
    private mainController: MainControllerComponent,
  ) {
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.appService.selectedQueueType.subscribe((type: any) => {
      this.queueType = type;
    });
  }
  
  ngAfterViewInit(): void {

  }

  async ngOnInit(): Promise<void> {
   this.getFailureDispositions();
  }
  getFailureDispositions() {
    this.tmQueueService.getFailureDispositions().subscribe(data => {
      this.dispositions=data.Response.Data;
    });
  }
  submitCall()
  {
    if(this.callDisposition!="0")
    {
        let payload={
          callID:this.queueService.getCallID(),
          disposition:this.callDisposition,
          activityID:this.activityId,
          notes:this.notes,
          isTransfer:false,
          isRelatedCall:false,
          calleeUserId:null,
          parentInteractionID:null
        }
        this.managerService.submitFailure(payload).subscribe((res)=>
        {
          if (res.Response.Status === 1) {
            this.queueService.SetDisableHeader(false);
            if (this.queueType == 'Inbound') {
              this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/Inbound']);
            } else if (this.queueType == 'Outbound') {
              this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/Outbound']);
            } else if (this.queueType == 'Search') {
              this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/Search']);
            }
            this.bsModalRef.hide();
       
           this.mainController.saveVideoRecording(res.Response.Data.InteractionID);
          }
        });
    }
    else
    this.invalidDisposition=true;
  
  }

  cancel() {
    this.bsModalRef.hide();
  }

}
